<aside id="mainSatelliteLockList" class="col-md-12 mb-0 h-100-margin">
  <div class="container-list h-100-margin">
    <div class="container-list-header">
      <div class="row m-0 p-0 pb-3 align-items-baseline justify-content-between">
        <app-list-filter [options]="optionsFilter" [filterBy]="'satelliteLock'"
          (refreshList)="getSatelliteLocks($event)"></app-list-filter>
        <button matTooltip="Crear Candado Satelital" mat-raised-button color="primary" permission-display
          [module]="permission.administration.module" [functionality]="permission.administration.createSatelliteLock"
          class="bg-color-primary button-width-auto text-bold" (click)="goToCreate()">
          <i class="fas fa-plus-circle mr-2 d-none d-sm-inline"></i>
          <span>Crear candado</span>
        </button>
      </div>
    </div>
    <div class="container-list-body mt-4 mt-lg-0" infinite-scroll *ngIf="service.paginationList.getList().length"
      [infiniteScrollDistance]="service.paginationList.getScrollDistance()"
      [infiniteScrollThrottle]="service.paginationList.getThrottle()" [scrollWindow]="false"
      (scrolled)="onScrollDown()">
      <div class="col-md-12 mb-md-0 mb-12 p-0 pl-2"
        *ngFor="let satelliteLock of service.paginationList.getList(); let i = index;">
        <app-item-satellite-lock [satelliteLock]="satelliteLock">
        </app-item-satellite-lock>
      </div>
    </div>
    <div *ngIf="!service.paginationList.getList().length" class="container_no_results h-100">
      <h4 class="text-bold text-center">No hay resultados que coincidan con la búsqueda</h4>
    </div>
  </div>
</aside>